import { Card, CardBody, Col, Row, Table } from 'reactstrap';
import React, { useEffect, useState } from 'react';

import { Button } from '../../components';
import { toast } from 'react-toastify';
import { ProfessionSearchCountReportDto } from '../../common/Types';
import { reportService } from '../../services/ReportService';

const ProfessionSearchCountReport = () => {
    const [statusReport, setStatusReport] = useState<ProfessionSearchCountReportDto>();

    useEffect(() => {
        const loadReport = () => {
            const toastId = toast.info('Searching...', {
                autoClose: false,
            });
            reportService
                .getProfessionSearchCountReport()
                .then((response) => {
                    setStatusReport(response);
                    toast.update(toastId, {
                        type: 'success',
                        autoClose: 500,
                        closeOnClick: true,
                        draggable: true,
                    });
                })
                .catch(() => toast.error('Failed to generate report'));
        };
        loadReport();
    }, [setStatusReport]);

    const exportReport = () => {
        const toastId = toast.info('Generating report, this may take a minute...', {
            autoClose: false,
        });
        reportService
            .exportProfessionSearchCountReport()
            .then((report) => {
                if (report) {
                    const url = window.URL.createObjectURL(report);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `ProfessionSearchCountReport.xlsx`;
                    a.click();
                    toast.update(toastId, {
                        render: 'Report generated successfully.',
                        type: 'success',
                        autoClose: 2500,
                        closeOnClick: true,
                        draggable: true,
                    });
                }
            })
            .catch(() => {
                toast.error(`Unable to generate report`);
            });
    };

    return (
        <>
            <Card>
                <CardBody>
                    <Row>
                        <Col>
                            <div className="mb-3">
                                <h3>Profession Search Count Report</h3>
                            </div>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-2">
                        <Button type="button" color="info" onClick={() => exportReport()}>
                            Export Report
                        </Button>
                    </div>
                    <div className="mt-3">
                        <h4>Profession Search Count</h4>
                    </div>
                </CardBody>
                <Table>
                    <thead>
                        <tr>
                            <th>Profession</th>
                            <th>Search Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {statusReport?.professionSearchCountDtos ? (
                            statusReport.professionSearchCountDtos.map((record, i) => (
                                <tr key={record.professionId}>
                                    <td>{record.professionTitle}</td>
                                    <td>{record.searchCount}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={2}>No Results</td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Total Records</th>
                            <th>{statusReport?.recordCount}</th>
                        </tr>
                    </tfoot>
                </Table>
            </Card>
        </>
    );
};

export default ProfessionSearchCountReport;
